import { monitoringTreeConstants } from '../../constants';
import { IMonitoringTreeCollectionState, IMonitoringTreeCollectionAction } from '../../interfaces';

const defaultTrees = JSON.parse(window.localStorage.getItem('GET_MONITORING_TREES_PART_SUCCESS') || '{}');
/**
 * Monitoring tree collection reducer. Process actions and change application global state
 *
 * @param {Object} state Current application state
 * @param {Object} action Current action
 *
 * @return {Object}
 */
export function monitoringTreeCollection(state: IMonitoringTreeCollectionState = {
    trees: defaultTrees,
    firstLoad: true,
}, action: IMonitoringTreeCollectionAction): IMonitoringTreeCollectionState {

    switch (action.type) {

        case monitoringTreeConstants.GET_MONITORING_TREES_PART_SUCCESS: {

            const trees: any = { ...state.trees };

            trees[action.dashboardId] = [...action.data];

            window.localStorage.setItem('GET_MONITORING_TREES_PART_SUCCESS', JSON.stringify(trees));
            return {
                trees: trees,
                firstLoad: false,
            };
        }

        default:

            return state;
    }
}
